import { InfoMesssages } from 'types/infoMessages';
import VisaIcon from 'assets/icons/VisaIcon.svg';
import AmexIcon from 'assets/icons/AmexIcon.svg';
import DiscoverIcon from 'assets/icons/DiscoverIcon.svg';
import MasterCardIcon from 'assets/icons/MasterCardIcon.svg';
import OtherPaymentIcon from 'assets/icons/OtherPaymentIcon.svg';
import DirectTransferIcon from 'assets/icons/DirectTransferIcon.svg';
import CashIcon from 'assets/icons/CashIcon.svg';
import CheckIcon from 'assets/icons/CheckIcon.svg';
import ZelleIcon from 'assets/icons/ZelleIcon.svg';
import CheckDepositIcon from 'assets/icons/CheckDepositIcon.svg';
import {
  AmexIcon as AmexIconComponent,
  CheckDepositIcon as CheckDepositIconComponent,
  DiscoverIcon as DiscoverIconComponent,
  MasterCardIcon as MasterCardIconComponent,
  OtherPaymentIcon as OtherPaymentIconComponent,
  VisaIcon as VisaIconComponent
} from 'assets/icons';
import { ReceiptByIdResponse } from './receipt.model';
import { If } from 'components';
import { getDisputeStatusColor } from 'containers/disputes/utils';
import { getInvoiceStatus } from 'containers/invoices/utils';
import { getInvoiceStatusColor } from 'containers/invoices/utils';
import {
  ManualPaymentMethodValues,
  ManualPaymentMethods,
  PaymentMethodFilterKeys,
  PaymentMethodsForInvoiceFilter
} from 'containers/home/components/constants';
import { PaymentMethods } from 'constants/common';
import { ReceiptStatus } from './receipts.model';
import { store } from 'store/store';
import { CARD_NETWORK, StatusFilters } from './constants';
import {
  ACHIcon,
  AffirmIcon,
  AfterpayIcon,
  CardStrokeIcon,
  KlarnaIcon,
  ManualCheckIcon,
  ManualOtherIcon,
  ManualPaymentIcon,
  SunbitIcon,
  TTPIcon,
  ZelleIcon as ZelleIconComponent
} from 'assets/payment-method-icons';
import DateUtils from 'utils/dateUtils';

export const isEmpty = (value: string) => {
  return !value || value.length === 0;
};

export const getReceiptStatus = (status: string) => {
  switch (status) {
    case ReceiptStatus.CANCELLED:
      return 'Canceled';
    case ReceiptStatus.FAILED:
      return 'Failed';
    case ReceiptStatus.PENDING:
      return 'Pending';
    case ReceiptStatus.SUCCESS:
      return 'Success';
    case ReceiptStatus.REFUNDED:
      return 'Refunded';
    case ReceiptStatus.BLOCKED:
      return 'Blocked';
    case ReceiptStatus.TIMED_OUT:
      return 'Timed Out';
    case ReceiptStatus.INITIATED:
      return 'Initiated';
    case ReceiptStatus.REFUND_INITIATED:
      return 'Refund initiated';
    case ReceiptStatus.REFUND_RETURNED:
      return 'Refund returned';
    case ReceiptStatus.REFUND_FAILED:
      return 'Refund failed';
    case ReceiptStatus.REFUND_CANCELLED:
      return 'Refund canceled';
    case ReceiptStatus.VOID:
      return 'Void';
    case ReceiptStatus.DISPUTED:
      return 'Disputed';
    case ReceiptStatus.RETURNED:
      return 'Returned';
    default:
      return status;
  }
};

export const getPayoutStatus = (status: string) => {
  switch (status) {
    case 'ON_HOLD':
      return 'On hold';
    case 'FAILED':
      return 'Failed';
    case 'PENDING':
    case 'IN_TRANSIT':
      return 'In transit';
    case 'SUCCESS':
      return 'Success';
    default:
      return '';
  }
};

export const getReceiptStatusColor = (status: string) => {
  switch (status) {
    case ReceiptStatus.CANCELLED:
    case ReceiptStatus.FAILED:
    case ReceiptStatus.VOID:
    case ReceiptStatus.RETURNED:
      return '#FF7A7A';
    case ReceiptStatus.PENDING:
      return '#F2994A';
    case ReceiptStatus.SUCCESS:
      return '#419364';
    case ReceiptStatus.REFUND_INITIATED:
    case ReceiptStatus.REFUNDED:
    case ReceiptStatus.REFUND_RETURNED:
    case ReceiptStatus.REFUND_CANCELLED:
    case ReceiptStatus.REFUND_FAILED:
      return '#3876BB';
    case ReceiptStatus.BLOCKED:
      return '#FF0000';
    case ReceiptStatus.TIMED_OUT:
      return '#800000';
    case ReceiptStatus.INITIATED:
      return '#4F4F4F';
    default:
      return '#4F4F4F';
  }
};

export const getPayoutStatusColor = (status: string) => {
  switch (status) {
    case 'ON_HOLD':
      return '#F2994A';
    case 'FAILED':
      return '#FF7A7A';
    case 'PENDING':
      return '#F2B85C';
    case 'SUCCESS':
      return '#419364';
  }
};

export const getReceiptStatusBackgroundColor = (status: string) => {
  switch (status) {
    case ReceiptStatus.CANCELLED:
      return '#F2B85C';
    case ReceiptStatus.FAILED:
    case ReceiptStatus.BLOCKED:
    case ReceiptStatus.VOID:
    case ReceiptStatus.RETURNED:
      return '#F7C0C0';
    case ReceiptStatus.PENDING:
      return '#F7E2C0';
    case ReceiptStatus.SUCCESS:
      return '#CBF4C9';
    case ReceiptStatus.REFUNDED:
    case ReceiptStatus.INITIATED:
    case ReceiptStatus.REFUND_INITIATED:
    case ReceiptStatus.REFUND_RETURNED:
      return '#A4D7FA';
    case ReceiptStatus.TIMED_OUT:
      return '#ECF1F7';
    default:
      return '#ECF1F7';
  }
};
export const getReceiptDetailStatusColor = (status: string) => {
  switch (status) {
    case ReceiptStatus.CANCELLED:
    case ReceiptStatus.FAILED:
    case ReceiptStatus.PENDING:
    case ReceiptStatus.SUCCESS:
    case ReceiptStatus.REFUND_INITIATED:
    case ReceiptStatus.REFUNDED:
    case ReceiptStatus.INITIATED:
    case ReceiptStatus.REFUND_RETURNED:
    case ReceiptStatus.VOID:
    case ReceiptStatus.RETURNED:
      return '#3E556D';
    case ReceiptStatus.BLOCKED:
      return '#FF0000';
    case ReceiptStatus.TIMED_OUT:
      return '#800000';
    default:
      return '#3E556D';
  }
};

export const getRefundDisabledReason = (
  isManualPayment,
  refundPermissions,
  isCreatedBySelf,
  isAlreadyRefunded,
  paymentMethod,
  isRefundExpired
) => {
  if (isManualPayment) return InfoMesssages.refundManualPaymentDisabledMessage;
  if (isAlreadyRefunded) return InfoMesssages.refundAlreadyProcessedDisabledMessage;
  if (!(refundPermissions.createRefundsByTeam || (isCreatedBySelf && refundPermissions.createRefundsBySelf))) {
    return InfoMesssages.refundNoPermissionMessage;
  }
  if (paymentMethod === PaymentMethods.MOBILE_CHECK_DEPOSIT || paymentMethod === 'check-deposit')
    return InfoMesssages.refundCheckDepositDisabledMessage;
  if (isRefundExpired) return 'Refund is not allowed as the refund window has expired';
  return 'Refund is not allowed for this payment method';
};

export const shouldEnableRefund = (
  isManualPayment,
  refundPermissions,
  isCreatedBySelf,
  isAlreadyRefunded,
  paymentMethod,
  isRefundExpired
) => {
  return (
    !isManualPayment &&
    !isAlreadyRefunded &&
    (refundPermissions.createRefundsByTeam || (isCreatedBySelf && refundPermissions.createRefundsBySelf)) &&
    paymentMethod !== PaymentMethods.MOBILE_CHECK_DEPOSIT &&
    paymentMethod !== 'check-deposit' &&
    !isRefundExpired
  );
};

export function getCardType(cardType) {
  switch (cardType.toLowerCase()) {
    case CARD_NETWORK.AMEX:
      return 'AMEX';
    case CARD_NETWORK.VISA:
      return 'Visa';
    case CARD_NETWORK.DISCOVER:
      return 'Discover';
    case CARD_NETWORK.MASTERCARD:
      return 'Mastercard';
    default:
      return 'Other';
  }
}

export function getCardIcon(cardType) {
  switch (cardType.toLowerCase()) {
    case CARD_NETWORK.AMEX:
      return AmexIcon;
    case CARD_NETWORK.VISA:
      return VisaIcon;
    case 'discover':
      return DiscoverIcon;
    case CARD_NETWORK.MASTERCARD:
      return MasterCardIcon;
    default:
      return OtherPaymentIcon;
  }
}

export function getCardIconComponent(cardType) {
  switch (cardType.toLowerCase()) {
    case CARD_NETWORK.AMEX:
      return AmexIconComponent;
    case CARD_NETWORK.VISA:
      return VisaIconComponent;
    case 'discover':
      return DiscoverIconComponent;
    case CARD_NETWORK.MASTERCARD:
      return MasterCardIconComponent;
    default:
      return OtherPaymentIconComponent;
  }
}

export function getPaymentMethodIcon(paymentMethod) {
  switch (paymentMethod) {
    case ManualPaymentMethodValues.DIRECT_TRANSFER:
      return DirectTransferIcon;
    case ManualPaymentMethodValues.CASH:
      return CashIcon;
    case ManualPaymentMethodValues.CHECK:
      return CheckIcon;
    case ManualPaymentMethodValues.ZELLE:
      return ZelleIcon;
    case ManualPaymentMethodValues.OTHER:
      return OtherPaymentIcon;
    case PaymentMethods.MOBILE_CHECK_DEPOSIT:
      return CheckDepositIcon;
    default:
      return OtherPaymentIcon;
  }
}

export const getReceiptPanelPaymentMethodData = (receiptData: ReceiptByIdResponse) => {
  const paymentMethodLabel = receiptData?.paymentMethod || '-';
  const shouldShowPaymentMethodIcon = paymentMethodLabel !== '-';
  const paymentMethodIconSrc = receiptData?.paymentMethodIcon || OtherPaymentIcon;
  const showReferenceNote = Boolean(receiptData?.referenceNote);

  return (
    <>
      <div className="flex flex-wrap items-center justify-end text-right leading-none">
        {shouldShowPaymentMethodIcon && (
          <img
            className="mr-1.5 h-3 w-5 shrink-0 object-contain"
            src={paymentMethodIconSrc}
            alt={`${paymentMethodLabel} icon`}
            loading="eager"
            decoding="sync"
            width={20}
            height={12}
            onError={event => {
              event.currentTarget.onerror = null;
              event.currentTarget.src = OtherPaymentIcon;
            }}
          />
        )}
        <span>{paymentMethodLabel}</span>
        {receiptData?.isManualKeyed && <span className="ml-1">(Keyed-in)</span>}
        {receiptData?.chargedCardOnFile && <span className="ml-1">(Card on file)</span>}
      </div>
      <If condition={showReferenceNote}>
        <div className="mt-2 whitespace-normal text-end text-[13px] font-medium text-accentText">
          {receiptData.referenceNote}
        </div>
      </If>
    </>
  );
};

export const getRelatedItemsStatus = (status, type: string) => {
  switch (type) {
    case 'DISPUTE':
      return <div style={{ color: getDisputeStatusColor(status) }}>{getReceiptStatus(status)}</div>;
    case 'PAYOUT':
      return <div style={{ color: getPayoutStatusColor(status) }}>{getPayoutStatus(status)}</div>;
    case 'INVOICE':
      return <div style={{ color: getInvoiceStatusColor(status) }}>{getInvoiceStatus(status)}</div>;
    case 'REFUND':
      if (status === 'REFUND_RETURNED') {
        return <div style={{ color: '#3E556D' }}>Refund returned</div>;
      }
      return <div style={{ color: '#3E556D' }}>{getReceiptStatus(status)}</div>;
    case 'RECEIPT':
      return <div style={{ color: getReceiptStatusColor(status) }}>{getReceiptStatus(status)}</div>;
    case 'RETURN':
      return <div style={{ color: '#FF7A7A' }}>Returned</div>;
    default:
      return <div style={{ color: '#3E556D', textTransform: 'capitalize' }}>{status?.toLowerCase()}</div>;
  }
};

export const getPaymentMethod = ({ cardLast4, network, paymentMethod, isManualKeyed }) => {
  if (cardLast4 && network) {
    return (
      <>
        <div className="flex flex-wrap items-center gap-1">
          <div>{getCardType(network)}</div>
          <div>{cardLast4}</div>
          {isManualKeyed && <div>(Keyed-in)</div>}
        </div>
      </>
    );
  }
  let paymentMethodText = '';
  paymentMethodText = paymentMethod ? ManualPaymentMethods.find(item => item.key === paymentMethod)?.value : '';
  if (!paymentMethodText) {
    paymentMethodText = paymentMethod
      ? PaymentMethodsForInvoiceFilter.find(item => item.key === paymentMethod)?.value
      : '';
  }
  return <div>{paymentMethodText || '-'}</div>;
};

export const getReceiptStatusFilter = () => {
  const { app } = store.getState().rootReducer;
  const { teamFeatures } = app.merchantCustomizations || {};
  const { showCheckDepositInFilters } = teamFeatures?.configs || {};

  if (showCheckDepositInFilters) {
    return [
      ...StatusFilters,
      {
        key: 'VOID',
        value: 'Void'
      },
      {
        key: 'RETURNED',
        value: 'Returned'
      }
    ];
  }

  return StatusFilters;
};

export const getPaymentMethodIconComponent = (paymentMethod: string) => {
  switch (paymentMethod) {
    case PaymentMethodFilterKeys.CARD:
      return CardStrokeIcon;
    case PaymentMethodFilterKeys.ACH:
      return ACHIcon;
    case PaymentMethodFilterKeys.KLARNA:
      return KlarnaIcon;
    case PaymentMethodFilterKeys.SUNBIT:
      return SunbitIcon;
    case PaymentMethodFilterKeys.AFFIRM:
      return AffirmIcon;
    case PaymentMethodFilterKeys.AFTERPAY:
      return AfterpayIcon;
    case PaymentMethodFilterKeys.MANUAL_CASH:
      return ManualPaymentIcon;
    case PaymentMethodFilterKeys.MANUAL_CHECK:
      return ManualCheckIcon;
    case PaymentMethodFilterKeys.MANUAL_DIRECT_TRANSFER:
      return ACHIcon;
    case PaymentMethodFilterKeys.MANUAL_OTHER:
      return ManualOtherIcon;
    case PaymentMethodFilterKeys.MANUAL_ZELLE:
      return ZelleIconComponent;
    case PaymentMethodFilterKeys.CHECK_DEPOSIT:
      return CheckDepositIconComponent;
    case PaymentMethodFilterKeys.TTP:
      return TTPIcon;
    default:
      return ManualOtherIcon;
  }
};

export const formatTransactionDate = (dateString: string): string => {
  if (!dateString) return '';

  try {
    const now = DateUtils.getNow();
    const transactionDate = DateUtils.parseISODateString(dateString);

    if (isNaN(transactionDate.getTime())) return '';

    const daysDiff = DateUtils.getDifferenceInDays({ primaryDate: now, secondaryDate: transactionDate });

    let hours = transactionDate.getHours();
    const minutes = transactionDate.getMinutes();
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12;
    const timeFormatted =
      minutes === 0 ? `${hours} ${ampm}` : `${hours}:${minutes.toString().padStart(2, '0')} ${ampm}`;

    if (daysDiff === 0) {
      return `Today, ${timeFormatted}`;
    }

    if (daysDiff === 1) {
      return `Yesterday, ${timeFormatted}`;
    }

    const dateFormatted = DateUtils.getDateInFormat({ date: transactionDate, dateFormat: 'MMM d, yyyy' });
    return `${dateFormatted}, ${timeFormatted}`;
  } catch (error) {
    return '';
  }
};
